<template>
  <el-dialog
    v-if="visible"
    v-el-dialog-drag
    show-close
    visible
    width="400px"
    title="派单"
    :close-on-click-modal="false"
    :before-close="() => close()"
  >
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      label-position="left"
      label-width="60px"
      inline-message
    >
      <el-row>
        <el-form-item label="司机" prop="driverCode">
          <dict-select
            filterable
            clearable
            v-model="formData.driverCode"
            :selectedLabel.sync="formData.driverName"
            :url="driverUrl"
            :body="driverParams"
            placeholder="请选择司机"
          />
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="车辆" prop="vehicleCode">
          <dict-select
            filterable
            clearable
            v-model="formData.vehicleCode"
            :selectedLabel.sync="formData.vehicleNo"
            :url="vehicleUrl"
            :body="vehicleParams"
            placeholder="请选择车辆"
          />
        </el-form-item>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button size="small" @click="close()">取消</el-button>
      <el-button type="primary" size="small" @click="save()"
        >确认派单</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
import validate from '@/libs/util.validate'
export default {
  props: {
    listWaybill: {
      type: Array,
      default: () => [],
    },
    visible: {
      type: Boolean,
      default: () => false,
    },
  },
  watch: {
    listWaybill: {
      handler(listWaybill) {
        if (listWaybill.length) {
          this.driverParams.carrierCode = listWaybill[0].carrierCode
          this.vehicleParams.carrierCode = listWaybill[0].carrierCode
          if (listWaybill.length === 1) {
            this.formData.driverCode = listWaybill[0].driverCode
            this.formData.driverName = listWaybill[0].driverName
            this.formData.vehicleCode = listWaybill[0].vehicleCode
            this.formData.vehicleNo = listWaybill[0].vehicleNo
          } else {
            this.formData.driverCode = ''
            this.formData.driverName = ''
            this.formData.vehicleCode = ''
            this.formData.vehicleNo = ''
          }
        }
      },
      immediate: true,
      deep: true,
    },
    'formData.driverCode'() {
      const carrierCode = this.listWaybill[0].carrierCode
      const driverCode = this.formData.driverCode
      if (!driverCode) {
        if (!carrierCode) {
          this.vehicleUrl = '/master/vehicle/info/select'
          this.vehicleParams = {}
        } else {
          this.vehicleUrl =
            '/master/vehicle/driver/vehicleListByDriverAndCarrier'
          this.vehicleParams = {
            carrierCode: carrierCode,
          }
        }
      } else {
        this.vehicleUrl = '/master/vehicle/driver/vehicleListByDriverAndCarrier'
        this.vehicleParams = {
          driverCode: driverCode,
          carrierCode: carrierCode,
        }
      }
    },
    'formData.vehicleCode'() {
      const carrierCode = this.listWaybill[0].carrierCode
      const vehicleCode = this.formData.vehicleCode
      if (!vehicleCode) {
        if (!carrierCode) {
          this.driverUrl = '/master/driver/info/select'
          this.driverParams = {}
        } else {
          this.driverUrl =
            '/master/vehicle/driver/driverListByVehicleAndCarrier'
          this.driverParams = {
            carrierCode: carrierCode,
          }
        }
      } else {
        this.driverUrl = '/master/vehicle/driver/driverListByVehicleAndCarrier'
        this.driverParams = {
          vehicleCode: vehicleCode,
          carrierCode: carrierCode,
        }
      }
    },
  },
  data() {
    return {
      formData: {
        driverCode: '',
        driverName: '',
        vehicleCode: '',
        vehicleNo: '',
      },
      listWaybillCode: [],
      vehicleUrl: '/master/vehicle/driver/vehicleListByDriverAndCarrier', //master/vehicle/info/select
      vehicleParams: {},
      driverUrl: '/master/vehicle/driver/driverListByVehicleAndCarrier',
      driverParams: {},
      rules: {},
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return

      const listWaybillCode = this.listWaybill.map((i) => {
        return i.waybillCode
      })
      const params = {
        listWaybillCode,
        ...this.formData,
      }
      let loadingInstance = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      this.$api
        .bizWaybillAssignApi(params)
        .then((res) => {
          loadingInstance.close()
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.$emit('reload')
          this.close()
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
  },
}
</script>
